// eslint-disable-next-line jira/restricted/use-debounce
import { useDebounce } from 'use-debounce';
import { useQueryParamsSync } from '@atlassian/jira-software-router-utils';
import { queryParamsToWatch } from '../../common/constants';
import { usePullRequestTableOptionsStore } from '../pull-request-filters';
import type { PullRequestTableOptions as State } from '../pull-request-filters/types';
import {
	getQueryParamsFromPullRequestTableOptions,
	getPullRequestTableOptionsFromQueryParams,
} from './utils';

export const useQueryParamSync = () => {
	const [pullRequestTableOptionsState, actions] = usePullRequestTableOptionsStore();
	const [debouncedState] = useDebounce(pullRequestTableOptionsState, 500);
	useQueryParamsSync<State>({
		state: debouncedState,
		onStateChange: actions.setPullRequestTableOptions,
		onReset: actions.resetState,
		getQueryParamsFromState: getQueryParamsFromPullRequestTableOptions,
		getStateFromQueryParams: getPullRequestTableOptionsFromQueryParams,
		queryParamsToWatch,
	});
};
